// removed by extract-text-webpack-plugin
module.exports = {"container":"G7f51c4","header":"Gab3863 Gfbbf38","messageContainer":"Ge3f47a G3c3c24","ctaContainer":"G900e35"};